import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { Products, Quote } from './types';
import { atomEffect } from 'jotai-effect';
import { getFirstOfNextThreeMonths } from '@/lib/utils';
import { Dependent } from '@/state/types';

export const defaultValues: Quote = {
  customer: {
    firstName: '',
    lastName: '',
    age: '',
    email: '',
    zipCode: '',
    state: '',
    dob: '',
    sourceOfLead: {
      name: '',
    },
    startDate: getFirstOfNextThreeMonths(new Date(), 1).toString(),
    spouse: undefined,
    dependents: [] as Dependent[],
    emailVerified: false,
  },
  product: Products.Dental,
  productCode: undefined,
  planCode: undefined,
  monthlyPrice: NaN,
  pricingTier: undefined,
  planName: undefined,
  planDetailsPdf: undefined,
  stateSpecificQuestions: undefined,
};

const storage = createJSONStorage<Quote>(() => sessionStorage);
export const quote = atomWithStorage<Quote>(
  'quoteInfo',
  defaultValues,
  storage
);

// This sets quote.planCode from initially undefined to either empty string ('') or
// a valid planCode once atom is ready to be read
export const validatePlanCodeEffect = atomEffect((get, set) => {
  const quoteValue = get(quote);
  if (typeof quoteValue.planCode === 'undefined') {
    set(quote, {
      ...quoteValue,
      planCode: '',
    });
  }
});
